// extracted by css-extract-rspack-plugin
export default {"folder-description":"P5E97k","folderDescription":"P5E97k","anon-pagination-blocker":"_CLZIj","anonPaginationBlocker":"_CLZIj"};